export default __webpack_public_path__ + "static/media/instagram-white.46233966.svg";